import flocknoteStateHooks from "Flocknote/stateHooks";

import { useSignupListHasRespondents } from "Signups/SignupView/utils/useSignupListHasRespondents";

export function useShouldShowSignupBoard() {
  const [{ hasFNP }] = flocknoteStateHooks.useNetworkMetadata();
  const hasRespondents = useSignupListHasRespondents();

  return hasFNP && hasRespondents;
}
